<template>
  <form name="receipt"
        method="get">
    <input type="hidden" name="receiptType" :value="receiptType">
    <input type="hidden" name="tid" :value="tid">
    <input type="hidden" name="directCall" :value="directCall">
  </form>
  <teleport to="body">
    <iframe v-if="isShow"
            style="display: none;"
            name="popupReceipt"></iframe>
  </teleport>
</template>

<script setup>
import {defineExpose, nextTick, onMounted, ref} from "vue";

const midType = ref('bill');

const receiptType = ref('general'); // general: 거래명세서, cash: 현금영수증
const tid = ref('');
const directCall = ref('Y');

const isShow = ref(false);

const show = (params) => {
  midType.value = params.midType ? params.midType : midType.value;
  receiptType.value = params.receiptType ? params.receiptType : receiptType.value;
  tid.value = params.tid;
  directCall.value = params.directCall ? params.directCall : directCall.value;

  isShow.value = true;

  nextTick(() => {
    const messageListner = function() {
    };
    window.addEventListener('message', messageListner);

    document.receipt.action = "/onpay/p1/" + midType.value + "/v1/receipt";
    document.receipt.target = "popupReceipt";
    document.receipt.submit();
  });
}

defineExpose({
  show
});

onMounted(() => {
})
</script>

<style scoped>

</style>
